;(function($, undefined){

    var rnn = window.rnn;

    function fetchMonth(month){
        var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
        var stringMonth = months[month-1];

        return stringMonth;
    }

    function genDate(date){
        var shortDate = date.split(" ")[0],
            userYear= parseInt(shortDate.split("-")[0]),
            month = shortDate.split("-")[1],
            currDate = new Date(),
            currYear = currDate.getFullYear(),
            printString;

        if(currYear > userYear){
            printString = "Member since " + userYear;
        }else{
            var stringMonth = fetchMonth(month);
            printString = "Member since " + stringMonth;
        }

        return printString;
    }

    // Initialise the user personalisation
    function initUserPersonalisation() {
        rnn.modules.user.get(function (user) {
            var $htmlEl;

            $htmlEl = $('html');

            if (user.authenticated) {
                $('*[data-user-property]').each(function () {
                    var $propEl, property, html;

                    $propEl = $(this);
                    property = $propEl.attr('data-user-property');

                    if (property == 'display_name') {
                      html = rnn.modules.utilities.niceWordTrunc(user[property], 35);
                    } else {
                      html = user[property];
                    }

                    $propEl.html(html || '');

                    // set the profile image and username in the li.user-info element
                    var $smallprofile25 = $('.small-profile.small-profile-25px'),
                        $smallprofile40 = $('.small-profile.small-profile-40px'),
                        $username = $('.user-details .username'),
                        $joinedDate = $('.user-details .joined-date'),
                        avatarURL = unescape(user.encoded_avatar_url),
                        printDate = genDate(user.date_joined);

                    $smallprofile25.css('background-image', 'url(' + avatarURL + ')').find('#hatProfileImg').attr('src', avatarURL);
                    $smallprofile40.css('background-image', 'url(' + avatarURL + ')');
                    $username.html(user.username);
                    $joinedDate.html(printDate);
                });
                $htmlEl.addClass('authenticated-user').removeClass('non-authenticated-user');
                if (user.is_staff) {
                    $htmlEl.addClass('staff-user').removeClass('non-staff-user');
                }
                if (user.subscribed === true) {
                    $htmlEl.addClass('subscribed-user').removeClass('non-subscribed-user');
                }

                if (!user.confirmed && window.location.href.indexOf(rnn.site.accountEditURL) < 0) {
                    rnn.modules.alert.show($(rnn.site.notificationWrapperClass), {
                        prepend: true,
                        type:'error',
                        message: '<span class="emailConfirmationAlertMessage">' +
                                 'You have not confirmed your email address. If you\'ve lost the email, ' +
                                 'you can <a href="#" data-url="' + rnn.site.accountConfirmURL + '">' +
                                 'resend a confirmation email</a>.</span>',
                        extraClass: 'emailConfirmationAlert'
                    });
                    rnn.modules.accounts.initEmailConfirmationAlerts();
                }

            } else {
               $('.navbar').find('.nav').find('.only-non-authenticated-user').removeClass('hide');
            }
        });
        $(rnn).on('login',initUserPersonalisation);
    }

    rnn.modules.register("userPersonalisation", {
        init: initUserPersonalisation
    });

})(jQuery);
